module.exports = __webpack_public_path__ + "img/banner-mobile.529c18ff.png";